const Changelog = () => {
  return (
    <div>Changelog</div>
  )
}

export default Changelog